import React from 'react'
import './button.scss'

const Button = ({ className, copy, type, onclick, arrow, loader, id }) => {
  return (
    <button
      id={id ? id : ''}
      type={type ? type : 'button'}
      className={
        'f-a-button ' +
        className +
        (arrow && !loader ? ' f-a-button-arrow' : '')
      }
      disabled={loader ? true : false}
      onClick={onclick}
    >
      <div className='f-a-button__inner'></div>
      {loader && loader !== 'disabled' && (
        <div className='f-a-button__loader'></div>
      )}
      <p
        style={
          loader && loader !== 'disabled' ? { color: 'transparent' } : null
        }
      >
        {copy ? copy : 'Botón'}
      </p>
    </button>
  )
}

export default Button
